export default {
  GENERATE_ID_URL: "/mypages/avytmpl/generate/",
};
